import { useSafeState } from 'ahooks';
import { AccountDetailType, AccountListType } from '@/pages/Mine/interface';
import {
  queryAccountBalance,
  queryAccountDetailList,
  // queryCustomerDetail,
} from '@/pages/Mine/My/service';
import { useModel } from '@umijs/max';
import { useEffect } from 'react';

export default function useAccount() {
  // 账户总余额
  const [totalAmount, setTotalAmount] = useSafeState<string>('0');
  const [accountList, setAccountList] = useSafeState<AccountListType[]>([]);
  const [accountDetailList, setAccountDetailList] = useSafeState<
    AccountDetailType[]
  >([]);
  // const [basicAccountInformation, setBasicAccountInformation] =
  useSafeState<AccountListType>();

  const { defaultCustomerId } = useModel('useDefaultCustomer', (model) => ({
    defaultCustomerId: model.defaultCustomerId,
  }));
  /**
   *  获取用户名下账户类型列表
   * @param params
   */
  const loadAccount = (params: { customerId: string }) => {
    queryAccountBalance(params).then((res) => {
      if (res.code === 200) {
        if (res.data) {
          const { totalBalance, accounts } = res?.data;
          setTotalAmount(totalBalance);
          setAccountList(accounts);
        }
      }
    });
  };

  /**
   * 获取用户名下账户详情列表
   * @param params
   */
  const loadAccountDetailList = (params: { customerId: string }) => {
    queryAccountDetailList(params).then((res) => {
      if (res?.code === 200) {
        if (res?.rows) {
          setAccountDetailList(res?.rows);
        }
      }
    });
  };

  const refreshAccount = () => {
    loadAccount({ customerId: defaultCustomerId! });
    loadAccountDetailList({ customerId: defaultCustomerId! });
  };

  useEffect(() => {
    if (defaultCustomerId) {
      loadAccount({ customerId: defaultCustomerId });
      loadAccountDetailList({ customerId: defaultCustomerId });
    }
  }, [defaultCustomerId]);

  return {
    totalAmount,
    accountList,
    // basicAccountInformation,
    accountDetailList,
    refreshAccount,
  };
}
